module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+PHBhdGggZD0iTTUwLjY3IDExLjc0Yy0xMy44MSAwLTI1IDExLjE5LTI1IDI1IDAgNS42MyAxLjg2IDEwLjgzIDUuMDEgMTUuMDEuMDUuMTMuMTEuMjUuMTkuMzdsMTguNyAyOC4yMWMuNjEuOTIgMS42LjkyIDIuMjEgMGwxOC41Ny0yOC4wMmMuMDktLjEzLjE1LS4yNy4yMS0uNDIgMy4yMS00LjIgNS4xMi05LjQ1IDUuMTItMTUuMTUtLjAxLTEzLjgtMTEuMjEtMjUtMjUuMDEtMjV6bTAgNDBjLTguMjggMC0xNS02LjcyLTE1LTE1IDAtOC4yOCA2LjcyLTE1IDE1LTE1IDguMjggMCAxNSA2LjcyIDE1IDE1IDAgOC4yOS02LjcyIDE1LTE1IDE1eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_location.svg
// module id = JX8C
// module chunks = 1